export default "__VITE_ASSET__CoCo_wPy__"